import React from 'react';
import { Row, Title } from 'library/ui';
import Checkmark from 'assets/icons/Checkmark.svg';

export default function ThanksForFeedback() {
    return (
        <Row gap="sm" justify="center" align="center" wrap>
            <Title size="h2">Thank you for your feedback!</Title>
            <Checkmark height={24} />
        </Row>
    );
}
